export default {
  subtitle: 'Das LaTeX, aus dem der Inhalt des Berichts erstellt wird. Leer lassen, um den Standardinhalt zu verwenden.',
};
